import { render, staticRenderFns } from "./choiceInspectionStandardNew.vue?vue&type=template&id=22a65ebc&scoped=true&"
import script from "./choiceInspectionStandardNew.vue?vue&type=script&lang=js&"
export * from "./choiceInspectionStandardNew.vue?vue&type=script&lang=js&"
import style0 from "./choiceInspectionStandardNew.vue?vue&type=style&index=0&id=22a65ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a65ebc",
  null
  
)

export default component.exports